import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { getTermReportConfigsErrorSelector, termReportConfigsSelector } from "../actions/selectors";
import { getTermReportConfigs } from "../actions";
import useApiLoading from "./useApiLoading";
import { GET_TERM_REPORT_CONFIGS_REQUEST } from "../actions/types";
var useTermReportsConfig = function() {
    var dispatch = useDispatch();
    var termReportConfigs = useSelector(termReportConfigsSelector);
    var getTermReportConfigsError = useSelector(getTermReportConfigsErrorSelector);
    var _useApiLoading = useApiLoading(GET_TERM_REPORT_CONFIGS_REQUEST), isGetTermReportsConfigLoading = _useApiLoading.isRequestPending;
    var handleGetTermReportConfigs = useCallback(function() {
        dispatch(getTermReportConfigs.request());
    }, [
        dispatch
    ]);
    useEffect(function() {
        if (!(termReportConfigs === null || termReportConfigs === void 0 ? void 0 : termReportConfigs.length) && !getTermReportConfigsError) {
            handleGetTermReportConfigs();
        }
    }, []);
    return {
        termReportConfigs: termReportConfigs,
        handleGetTermReportConfigs: handleGetTermReportConfigs,
        isGetTermReportsConfigLoading: isGetTermReportsConfigLoading,
        getTermReportConfigsError: getTermReportConfigsError
    };
};
export default useTermReportsConfig;

//# sourceMappingURL=useTermReportsConfig.js.map